import styled, { css } from 'styled-components';
import { normalizeString } from '../../../../utils/normalizeString';

interface HeaderProps {
  level: string;
}

export const Container = styled.div`
  padding: 20px;
  position: relative;
  width: 450px;
  transition: transform 0.2s;
  margin: 10px 0 31px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 930px) {
    max-width: 370px;
    padding-left: 10px;
  }

  @media (max-width: 540px) {
    max-width: 380px;
  }

  @media (max-width: 420px) {
    max-width: 340px;
  }

  @media (max-width: 380px) {
    max-width: 250px;
  }
`;

export const Header = styled.header<HeaderProps>`
  position: absolute;
  display: flex;

  top: 0px;
  left: 12px;

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    font-size: 1rem;

    color: #fff;

    width: 54px;
  }

  ${(props) => {
    if (normalizeString(props.level) === 'facil') {
      return css`
        p {
          background: ${({ theme }) => theme.smoothBlue};
        }
      `;
    } else if (normalizeString(props.level) === 'medio') {
      return css`
        p {
          background: ${({ theme }) => theme.purple};
        }
      `;
    } else if (normalizeString(props.level) === 'dificil') {
      return css`
        p {
          background: ${({ theme }) => theme.orange};
        }
      `;
    } else {
      return css`
        p {
          background: ${({ theme }) => theme.black};
        }
      `;
    }
  }}

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    span {
      padding: 0 4px;
      color: ${({ theme }) => theme.black};
      font-size: 1rem;
    }

    background: linear-gradient(
      90deg,
      rgba(220, 220, 233, 1) 0%,
      rgba(179, 175, 108, 1) 100%
    );
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 380px;
  height: 200px;
  background: ${({ theme }) => theme.backgroundCard};

  display: flex;
  align-items: center;

  > span {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 100px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-width: 210px;

    span {
      h1 {
        line-height: 36px;
        font-size: 2.2rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 32px;
        margin: 0;
        font-weight: 500;
        font-size: 1.25rem;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    width: 330px;
    height: 180px;

    > span {
      img {
        height: 90px;
      }
    }

    div {
      min-width: 190px;

      span {
        h1 {
          font-size: 1.8rem;
        }
      }
    }
  }

  @media (max-width: 412px) {
    width: 300px;
    height: 150px;

    > span {
      img {
        height: 80px;
      }
    }

    div {
      min-width: 100px;

      span {
        h1 {
          font-size: 1.5rem;
          line-height: 26px;
        }

        h2 {
          line-height: 22px;
        }
      }
    }
  }

  @media (max-width: 380px) {
    width: 220px;
    height: 130px;

    > span {
      img {
        height: 60px;
      }
    }

    div {
      min-width: 125px;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  position: absolute;
  right: 46px;
  bottom: -8px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 4px;

    height: 50px;
    width: 50px;

    svg {
      height: 20px;
      width: 20px;
      margin-bottom: 2px;
    }

    &:last-child {
      background: #000;
      color: #fff;
      border-radius: 0;
      padding: 15px;
      margin-left: 14px;
      margin-bottom: 0px;

      height: 55px;
      width: 55px;

      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(-45deg);

      svg {
        transform: rotate(45deg);
      }
    }
  }

  @media (max-width: 1024px) {
    right: 85px;
  }

  @media (max-width: 930px) {
    right: 15px;
  }

  @media (max-width: 768px) {
    right: 18px;
  }

  @media (max-width: 540px) {
    right: 24px;
  }

  @media (max-width: 420px) {
    right: 5px;
  }

  @media (max-width: 414px) {
    right: -15px;
  }

  @media (max-width: 412px) {
    right: 15px;
  }

  @media (max-width: 380px) {
    right: 8px;
    bottom: -5px;

    button {
      &:last-child {
        height: 40px;
        width: 40px;
      }
    }
  }
`;
